import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface DataSourceAttributionProps {
  explainer: string;
  source: string;
  endpoint?: string;
  reportingCutoff?: string;
  computedAt?: string;
}

const DataSourceAttribution: React.FC<DataSourceAttributionProps> = ({
  explainer,
  source,
  endpoint,
  reportingCutoff,
  computedAt,
}) => {
  const tooltipContent = [
    `Source: ${source}`,
    endpoint ? `Endpoint: ${endpoint}` : '',
    reportingCutoff ? `Reporting from: ${reportingCutoff}` : '',
    computedAt ? `Computed: ${new Date(computedAt).toLocaleString()}` : '',
  ].filter(Boolean).join('\n');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mt: 1.5,
        pt: 1,
        borderTop: '1px solid #F3F4F6',
      }}
    >
      <Tooltip title={tooltipContent} placement="top" arrow>
        <InfoOutlinedIcon sx={{ fontSize: '12px', color: '#9CA3AF', cursor: 'help' }} />
      </Tooltip>
      <Typography
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          fontSize: '10px',
          color: '#9CA3AF',
          lineHeight: 1.4,
        }}
      >
        {explainer}
      </Typography>
    </Box>
  );
};

export default DataSourceAttribution;
